<script>
  import { onMount } from "svelte";
  import { Chart } from "chart.js";

  let { data, chartDateLabels, isInModal = false } = $props();

  let followersChart = $state(null);
  let canvasId = `followersChart_${Math.random().toString(36).substr(2, 9)}`;

  function setupFollowersChart() {
    let snapspotData = $state.snapshot(data?.follower_growth);

    const followersCtx = document.getElementById(canvasId).getContext("2d");

    followersChart = new Chart(followersCtx, {
      type: "line",
      data: {
        labels: chartDateLabels(snapspotData?.dates || []),
        datasets: [
          {
            label: "Followers",
            data: snapspotData?.followers || [],
            fill: true,
            backgroundColor: "rgba(99, 102, 241, 0.2)",
            borderColor: "rgba(99, 102, 241, 1)",
            tension: 0.4,
            pointBackgroundColor: "rgba(99, 102, 241, 1)",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: false,
            ticks: {
              callback: function (value) {
                return Math.round(value).toLocaleString();
              },
            },
            grid: {
              color: "rgba(0, 0, 0, 0.1)",
            },
          },
          x: {
            grid: {
              color: "rgba(0, 0, 0, 0.1)",
            },
          },
        },
      },
    });
  }

  function updateFollowersChart() {
    if (!followersChart) return;

    let snapspotData = $state.snapshot(data?.follower_growth || {});
    followersChart.data.labels = chartDateLabels(snapspotData?.dates || []);
    followersChart.data.datasets[0].data = snapspotData?.followers || [];

    followersChart.update();
  }

  $effect(() => {
    updateFollowersChart();
  });

  // Resize chart when modal visibility changes
  $effect(() => {
    if (isInModal && followersChart) {
      setTimeout(() => {
        followersChart.resize();
      }, 100);
    }
  });

  onMount(() => {
    setupFollowersChart();

    return () => {
      if (followersChart) followersChart.destroy();
    };
  });
</script>

<div class="bg-white shadow rounded-lg p-6">
  <h3 class="text-lg font-medium text-gray-900 mb-4">
    Followers Growth {@html data?.follower_growth?.dates?.length < 3
      ? "<span class='text-gray-500 text-xs pl-1'>(more data will be collected over time)</span>"
      : ""}
  </h3>
  <div class={isInModal ? "h-96" : "h-64"}>
    <canvas id={canvasId}></canvas>
  </div>
</div>
